import { API_PATH_INTERNAL } from '@/lib/constants'
import apiService from '@/lib/services/apiService'
import { PaymentCollection } from '@/types/responses/payments'

class PaymentService {
  private endpoint = `${API_PATH_INTERNAL}/payments`

  async getPendingPayments() {
    const response = await apiService.get<PaymentCollection>(this.endpoint, {
      params: { status: 'PENDING' },
    })
    return response.data
  }

  async getPaymentsByIds(ids: number[]) {
    if (ids.length === 0) {
      throw new Error('No payment ids provided')
    }

    const response = await apiService.get<PaymentCollection>(this.endpoint, {
      params: { id: ids },
    })

    return response.data
  }
}

const paymentService = new PaymentService()

export default paymentService
